// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__4I8v5","title":"styles_title__MopYb"};